export default {
  title: "Banco"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5018: { text: "Ocurrió un error en el catálogo de Banco" }
    , WS5018: { text: "Ocurrió un error en el catálogo de Banco" }
    , JS5018: { text: "Ocurrió un error en el catálogo de Banco" }
    , CR5018: { text: "Ocurrió un error en el catálogo de Banco" }
    , UK_Banco: { text: "Ya existe un registro con la misma descripción" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/banco.js